import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createPaymentMethod(
  parentId: string,
  masterBlockId?: MasterBlockId,
): PaymentMethodInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PaymentMethod,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.PaymentMethod,
    fontSize: 16,
  }
}
